import { render, staticRenderFns } from "./rainbow-cup-normal.vue?vue&type=template&id=556a881b&scoped=true&"
import script from "./rainbow-cup-normal.vue?vue&type=script&lang=js&"
export * from "./rainbow-cup-normal.vue?vue&type=script&lang=js&"
import style0 from "./rainbow-cup-normal.vue?vue&type=style&index=0&id=556a881b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a881b",
  null
  
)

export default component.exports